import axios from 'axios';
import Jsona from 'jsona';

import http from '../api/http';
import config from '../../config';

import { authProcessorActions } from '../slices/authProcessor-slice';

export const authProcessorLogin = (
  ssn,
  countryCode,
  isLoginOnly,
  countryId,
  cityId,
  nationalityCountryCode,
  email,
  phone,
  successUri,
  cancelUri,
  rejectUri,
  isLinkOnly
) => {
  const request = axios.get('https://geolocation-db.com/json/');

  return (dispatch) => {
    dispatch(
      authProcessorActions.setAuthProcessorLoading({
        isLoading: true,
        willClearError: true,
      })
    );

    return request.then(
      ({ data }) => {
        dispatch(
          _authProcessorLogin(
            ssn,
            countryCode,
            countryId,
            cityId,
            nationalityCountryCode,
            email,
            phone,
            data.IPv4,
            successUri,
            cancelUri,
            rejectUri,
            isLinkOnly,
            isLoginOnly
          )
        );
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Login failed!';
          }
        }

        console.log('AuthProcessor authProcessorLogin error: ' + errorMessage);

        dispatch(authProcessorActions.setAuthProcessorError(errorMessage));
      }
    );
  };
};

const _authProcessorLogin = (
  ssn,
  countryCode,
  countryId,
  cityId,
  nationalityCountryCode,
  email,
  phone,
  endUserIp,
  successUri,
  cancelUri,
  rejectUri,
  isLinkOnly,
  isLoginOnly
) => {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL + config.REACT_APP_AUTH_PROCESSOR_URL;

  const objRequest = {
    data: {
      type: 'auth',
      attributes: {
        ssn,
        endUserIp,
        countryCode,
        bankIdAppRedirectReturnUrl:
          successUri || config.REACT_APP_AUTH_PROCESSOR_RETURNLINK,
        successUri: successUri || config.REACT_APP_AUTH_PROCESSOR_RETURNLINK,
        cancelUri: cancelUri || config.REACT_APP_AUTH_PROCESSOR_CANCELLINK,
        rejectUri: rejectUri || config.REACT_APP_AUTH_PROCESSOR_REJECTLINK,
        isLinkOnly,
        tenant: config.REACT_APP_TENANT,
      },
    },
  };

  const request = isLinkOnly
    ? http.post(apiBaseUrl, objRequest)
    : axios.post(apiBaseUrl, objRequest);

  return (dispatch) => {
    return request.then(
      ({ data }) => {
        const authProcessorData = new Jsona().deserialize(data);

        dispatch(
          authProcessorActions.setAuthProcessorStarted({
            id: authProcessorData.id,
            orderRef: authProcessorData.orderRef,
            ssn,
            sessionId: authProcessorData.sessionId,
            externalReference: authProcessorData.externalReference,
            countryCode,
            countryId,
            cityId,
            nationalityCountryCode,
            email,
            phone,
            endUserIp,
            tenant: config.REACT_APP_TENANT,
            authProcessorRedirectUrl: authProcessorData.redirectUrl,
            successUri:
              successUri || config.REACT_APP_AUTH_PROCESSOR_RETURNLINK,
            cancelUri: cancelUri || config.REACT_APP_AUTH_PROCESSOR_CANCELLINK,
            rejectUri: rejectUri || config.REACT_APP_AUTH_PROCESSOR_REJECTLINK,
            isLoginOnly,
          })
        );
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Login failed!';
          }
        }

        console.log('AuthProcessor _authProcessorLogin error: ' + errorMessage);

        dispatch(authProcessorActions.setAuthProcessorError(errorMessage));
      }
    );
  };
};

export const authProcessorCheck = (objAuthProcessor, isLinkOnly) => {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL +
    config.REACT_APP_AUTH_PROCESSOR_URL +
    '/' +
    objAuthProcessor.id;

  const objRequest = {
    data: {
      type: 'AuthProcessorRequest',
      attributes: {
        ...objAuthProcessor,
        tenant: config.REACT_APP_TENANT,
      },
    },
  };

  const request = isLinkOnly
    ? http.patch(apiBaseUrl, objRequest)
    : axios.patch(apiBaseUrl, objRequest);

  return (dispatch) => {
    return request.then(
      ({ data }) => {
        const authProcessorData = new Jsona().deserialize(data);

        if (
          authProcessorData.authCode &&
          authProcessorData.status.toLowerCase() === 'approved' &&
          authProcessorData.isResponseReceived
        ) {
          dispatch(
            authProcessorActions.setAuthProcessorAuthCode(
              authProcessorData.authCode
            )
          );
          dispatch(
            authProcessorActions.setAuthProcessorLoading({
              isLoading: false,
              willClearError: true,
            })
          );
        } else if (
          authProcessorData.status.toLowerCase() === 'started' ||
          authProcessorData.status.toLowerCase() === 'delivered_to_mobile'
        ) {
          dispatch(authProcessorActions.setAuthProcessorFireCheck());
        } else if (authProcessorData.status.toLowerCase() === 'exception') {
          dispatch(
            authProcessorActions.setAuthProcessorError(
              authProcessorData.failMessage
            )
          );
        } else {
          dispatch(authProcessorActions.setAuthProcessorCancelled());
          dispatch(
            authProcessorActions.setAuthProcessorLoading({
              isLoading: false,
              willClearError: true,
            })
          );
        }
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Login failed!';
          }
        }

        console.log('AuthProcessor authProcessorCheck error: ' + errorMessage);

        dispatch(authProcessorActions.setAuthProcessorError(errorMessage));
      }
    );
  };
};

export const authProcessorClearStarted = () => {
  return (dispatch) => {
    dispatch(authProcessorActions.clearAuthProcessorStarted());
  };
};

export const authProcessorClearFireCheck = () => {
  return (dispatch) => {
    dispatch(authProcessorActions.clearAuthProcessorFireCheck());
  };
};

export const authProcessorSetError = (errorMessage) => {
  return (dispatch) => {
    dispatch(authProcessorActions.setAuthProcessorError(errorMessage));
  };
};

export const authProcessorClearError = () => {
  return (dispatch) => {
    dispatch(authProcessorActions.clearAuthProcessorError());
  };
};

export const authProcessorClearState = () => {
  return (dispatch) => {
    dispatch(authProcessorActions.clearAuthProcessor());
  };
};
